import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPreference } from "../../../utilities/common";
import { abandonExpiredParcel, batchSendExpiredAlert, getAllClearingItems, testBatchSendExpiredAlert, deleteClearingEvent} from "../../../actions/ssmActions";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { CircularProgress, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { useToken } from "../../../utilities/hooks";
import ExcelDownloadButton from '../../Common/ExcelDownloadButton';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex', 
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    excelMargin: { 
        margin: theme.spacing(1)
    }
}));

const SYSTEM_ADMINISTRATOR = 'System Administrator';
const EXPIRED_MANAGEMENT = 302;
const SMS = 308;

function BatchExcel(props) {
    const classes = useStyles();
    const {t} = useTranslation('storageScan');
    const dispatch = useDispatch();
    let userPref = getUserPreference();
    const tokenContents = useToken();

    const userIsSystemAdministrator = tokenContents.roles.includes(SYSTEM_ADMINISTRATOR);
    const userHasExpiredManagement = tokenContents.uiAbilities.includes(EXPIRED_MANAGEMENT);
    const userHasSms = tokenContents.uiAbilities.includes(SMS);

    const storageManagement = useSelector(state => state.storageScanManagement);

    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [testOpen, setTestOpen] = useState(false);
    const [testPhone, setTestPhone] = useState('');
    const [failMsg, setFailMsg] = useState('');
    const [textOpen, setTextOpen] = useState(false);
    const [textOpenOperator, setTextOpenOperator] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleTestSMSOpen = () => {
        setTestOpen(true);
    }
    const hendleTestSMSClose = () => {
        setTestOpen(false);
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    }
    const handleDeleteClose = () => {
        setDeleteOpen(false);
    }

    useEffect(() => {
        if(storageManagement.textFunctionOpen === 'admin') {
            setTextOpen(true);
            setTextOpenOperator(true);
        } else if(storageManagement.textFunctionOpen === 'operator') {
            setTextOpen(false);
            setTextOpenOperator(true);
        } else {
            setTextOpen(false);
            setTextOpenOperator(false);
        }
    }, [storageManagement.textFunctionOpen])

    useEffect(() => {
        if(storageManagement.clearingItems) {
            setRows(storageManagement.clearingItems.data);
        }
    }, [storageManagement.clearingItems]);

    function sendSms(batchNo, branch) {
        dispatch(batchSendExpiredAlert(batchNo, branch))
        .then(() => {
            dispatch(getAllClearingItems(batchNo));    
        });
        setOpen(false);   
    }

    function handleDeleteClearingEvent(batchNo, branch) {
        setLoading(true);
        dispatch(deleteClearingEvent(batchNo, branch))
        .then(() => {
            dispatch(getAllClearingItems(batchNo));
            dispatch(showAlertSnackbar({message: t('delete_success_message'), type: 'success'}))
            setLoading(false);    
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('delete_fail_message'), type: 'error'}))
            setLoading(false);
        })
        setDeleteOpen(false);   
    }
    
    function handleExpired() {
        setLoading(true);
        dispatch(abandonExpiredParcel(props.warehouse, storageManagement.batchSendNo))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('abandon_success_message'), type: 'success'}))
            setLoading(false);
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('abandon_fail_message'), type: 'error'}))
            setLoading(false);
        })
    }

    return (
        <div className={classes.group}>
            <Dialog
                open={testOpen}
                onClose={hendleTestSMSClose}
            >
                <DialogContent>
                    <TextField
                        variant="outlined"
                        placeholder={t("input_test_phone")}
                        onChange={(e) => setTestPhone(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={hendleTestSMSClose} color="primary">
                        {t('cancel')}
                    </Button>
                    <Button onClick={handleTestSMS} color="primary" autoFocus>
                        {t('send')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogContent>
                    <DialogContentText>
                        {t('sure_to_send')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t('cancel')}
                    </Button>
                    <Button onClick={() => sendSms(storageManagement.batchSendNo, props.warehouse)} color="primary" autoFocus>
                        {t('send')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={deleteOpen}
                onClose={handleDeleteClose}
            >
                <DialogContent>
                    <DialogContentText>
                        {t('sure_to_delete')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteClose} color="primary">
                        {t('cancel')}
                    </Button>
                    <Button onClick={() => handleDeleteClearingEvent(storageManagement.batchSendNo, props.warehouse)} color="primary" autoFocus>
                        {t('ok')}
                    </Button>
                </DialogActions>
            </Dialog>
            <div className={classes.item}>{t('batch')}</div>
            <div className={classes.item}>{ storageManagement.batchSendNo || t('select_batch') }</div>
            <ExcelDownloadButton 
                rows={rows || []}
                name={t('storage_scan')}
                classes={classes}
            />
            {/* <Button
                variant="contained"
                color="primary"
                className={classes.margin}
                onClick={handleClickOpen}
                disabled={!userHasSms || loading}
            >
                {t('send_sms')}
            </Button>
            <Button
                variant="contained"
                color="primary"
                className={classes.margin}
                onClick={handleTestSMSOpen}
                disabled={!userHasSms || loading}
            >
                {t('test_sms')}
            </Button> */}
            <Button 
                variant="contained" 
                color="primary" 
                className={classes.margin}
                disabled={!userHasExpiredManagement || loading}
                onClick={handleExpired}
            >
                {t('expired')}
            </Button>
            <Button 
                variant="contained" 
                color="secondary" 
                className={classes.margin}
                disabled={!userIsSystemAdministrator || loading}
                onClick={handleDeleteOpen}
            >
                {t('delete_event')}
            </Button>
            {   loading && 
                <CircularProgress/>
            }
        </div>
    )

    function handleTestSMS() {
        dispatch(testBatchSendExpiredAlert(storageManagement.batchSendNo, props.warehouse, testPhone))
        .then(() => {
            setTestOpen(false);
        })
        .catch((error) => {
            setFailMsg(error.message);
            dispatch(showAlertSnackbar({message: error.message, type: 'error'}))
        })
    }
}

export default BatchExcel;